import React, { useState } from "react";
import "./Filter.css";
import { useDispatch, useSelector } from 'react-redux';
import { setFilters,resetFilters, fetchProducts } from '../../../Features/filter/fetch_products';
import { FaTshirt, FaCouch, FaBook, FaCar, FaBaseballBall, FaAppleAlt } from "react-icons/fa";

const Filter = () => {
  const dispatch = useDispatch();
  const selectedCategory = useSelector((state) => state.products.filters.category);
  const handleCategoryClick = (category) => {
    if (category === "All") {
      dispatch(resetFilters()); // Reset filters when "All" is selected
    } else {
      dispatch(setFilters({ category }));
    }
    dispatch(fetchProducts());
  };
  const categories = [
    { name: "All", icon: "📦" }, 
    { name: "Furniture", icon: <FaCouch /> },
    { name: "Clothing", icon: <FaTshirt /> },
    { name: "Books", icon: <FaBook /> },
    { name: "Sports", icon: <FaBaseballBall /> },
    { name: "Automotive", icon: <FaCar /> },
    { name: "Groceries", icon: <FaAppleAlt /> },
    { name: "Toys", icon: <FaCar /> },
    { name: "Beauty", icon: <FaCouch /> },
    
  ];

  return (
    <div>
      {/* Heading */}
      <h5 className="filterHeading">Product Categories</h5>

      {/* Categories Grid */}
      <div className="categories-container">
        {categories.map((category, index) => (
          <div
          key={index}
          className={`category-item ${selectedCategory === category.name ? "active" : ""}`}
          onClick={() => handleCategoryClick(category.name)}
           >
            <div className="category-icon">{category.icon}</div>
            <p className="category-name">{category.name}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Filter;

